import type {RouteComponent} from 'vue-router';
import useFeatures from '@/composables/useFeatures';

type RuleFormComponentLoader = () => Promise<RouteComponent>;

/**
 * A view that has no vee-validate form yet omits `veeValidate`, so both branches resolve to its
 * legacy form.
 *
 * TODO: FE-3757 - remove this helper with the legacy views and the toggle.
 */
export const resolveRuleFormComponent = (
  legacy: RuleFormComponentLoader,
  veeValidate: RuleFormComponentLoader = legacy,
): RuleFormComponentLoader => {
  return () => {
    const {isFeatureActive} = useFeatures();

    return isFeatureActive('rules.veeValidate') ? veeValidate() : legacy();
  };
};
